import styled from "styled-components";
import { MainCorrect, MainFrame, MainFrameWrapper, MainHeadingCapital, MainHeadingColor, MainQuestion, MainSection, MainSentenceWrapper } from "../../../components/01_config/MainStyles";
import { colors } from "../../../components/01_config/Colors";
import { sizes } from "../../../components/01_config/Sizes";


const Wrapper = styled.div`
    margin-top: ${sizes.headerheight};
`

const Header = styled.div`
    position: relative;
    padding: 50px;
    background-color: ${colors.reading};
    color: white;
    font-size: 3rem;
    font-weight: bold;
    text-transform: uppercase;
    @media(max-width: 800px) {
        padding: 30px 0;
        text-align: center;
        font-size: 2rem
    }
`

const TextsSection = styled(MainSection)`
    flex-direction: column;
    scroll-margin-top: ${sizes.headerheight};
    align-items: center;
`

const FrameWrapper = styled(MainFrameWrapper)`
`

const HeadingColor = styled(MainHeadingColor)`
    width: 100%;
    text-align: center;
`

const Topic = styled.div`
    text-decoration: underline;
    white-space: pre-wrap;
`

const Frame = styled(MainFrame)`
    width: 600px;
    flex-direction: column;
    gap: 30px;
    align-items: start;
`

const FrameHeading = styled(MainHeadingCapital)`
    margin: 0 auto;
    color: ${colors.myprogress};
    color: #044AEF;
    font-weight: bold;
    font-size: 1.4rem;
`

const DialogWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`

const SentenceWrapper = styled(MainSentenceWrapper)`
    // flex-direction: row;
    max-width: none;
    flex-wrap: wrap;
    line-height: 1;
`

const DialogName = styled.div`
    font-weight: bold;
`

const DialogLine = styled(MainQuestion)`
    font-style: italic;
    word-wrap: wrap;
    text-wrap: wrap;
`


const Correct = styled(MainCorrect)`
    display: block;
    line-height: 0.9;
`


export { Wrapper, Header, TextsSection, HeadingColor, Topic, FrameWrapper, Frame, FrameHeading, DialogWrapper, SentenceWrapper, DialogName, DialogLine, Correct }